import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Search from './Search';
import './Banner.css';

const Banner = ({ commandGroups, eventGroups }) => (
    <div className="banner">
        <Link to="/">GVH Commands & Events</Link>
        <Search commandGroups={commandGroups} eventGroups={eventGroups} />
    </div>
);

Banner.propTypes = {
    commandGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
    eventGroups: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Banner;
